import React, { useEffect, useRef, useState } from 'react';

import styled from '@emotion/styled';

import { GeneralFilterSchema } from '../../../components/DropDown/SelectorDropDown';
import CustomSelectField from '../../../components/FormCom/CustomBlueSelectField';
import { FormComponent } from '../../../components/FormCom/FormComponent';

type ChartFilterState = {
  year: string;
  month: string;
};

const monthOptions = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const now = new Date();
const formInitialState: ChartFilterState = {
  year: now.getFullYear().toString(),
  month: monthOptions[now.getMonth()],
};

const monthNameToNumber: Record<string, string> = {
  january: '01',
  february: '02',
  march: '03',
  april: '04',
  may: '05',
  june: '06',
  july: '07',
  august: '08',
  september: '09',
  october: '10',
  november: '11',
  december: '12',
};

interface ChartFilterProps {
  setDataUrl: (url: string) => void;
  dataUrl: string;
}

const ChartFilter: React.FC<ChartFilterProps> = ({ setDataUrl, dataUrl }) => {
  const baseDataUrlRef = useRef(dataUrl);
  const [filterObj, setFilterObj] =
    useState<Partial<ChartFilterState>>(formInitialState);

  useEffect(() => {
    const baseUrl = baseDataUrlRef.current;

    const selectedYear = String(filterObj.year ?? '').trim();
    const selectedMonthName = String(filterObj.month ?? '')
      .trim()
      .toLowerCase();
    const selectedMonthNumber = monthNameToNumber[selectedMonthName];

    const queryString =
      selectedYear && selectedMonthNumber
        ? `month=${encodeURIComponent(`${selectedYear}-${selectedMonthNumber}`)}`
        : '';

    if (!queryString) {
      setDataUrl(baseUrl);
      return;
    }

    if (baseUrl.includes('?')) {
      const separator =
        baseUrl.endsWith('?') || baseUrl.endsWith('&') ? '' : '&';
      setDataUrl(`${baseUrl}${separator}${queryString}`);
      return;
    }

    setDataUrl(`${baseUrl}?${queryString}`);
  }, [filterObj, setDataUrl]);

  const handleOnSubmit = () => {};

  const handleFieldChange = (fieldName: keyof ChartFilterState) => {
    return (value: string) => {
      setFilterObj((prevFilter) => ({
        ...prevFilter,
        [fieldName]: value,
      }));
    };
  };

  return (
    <Container>
      <WrapFormComponent
        initialValues={formInitialState}
        schema={GeneralFilterSchema}
        onSubmit={handleOnSubmit}
      >
        <CustomSelectField
          name='year'
          id='year'
          placeholder='Year'
          onChange={handleFieldChange('year')}
          optionData={Array.from({ length: 77 }, (_, i) =>
            (2024 + i).toString(),
          )}
        />
      </WrapFormComponent>
    </Container>
  );
};

export default ChartFilter;

const Container = styled.div``;

const WrapFormComponent = styled(FormComponent)`
  display: grid;
  grid-template-columns: 109px;
  gap: 8px;
`;
